{
  "tabs": {
    "chat": "Kutaura",
    "reminders": "Zvirangaridzo",
    "calendar": "Karenda",
    "settings": "Zvirongwa"
  },
  "common": {
    "cancel": "Kanzura",
    "save": "Chengeta",
    "confirm": "Simbisa",
    "delete": "Bvisa",
    "back": "Dzoka",
    "close": "Vhara",
    "edit": "Gadzirisa",
    "search": "Tsvaga",
    "all": "Zvese",
    "loading": "Kurodha...",
    "error": "Pane chakakanganisika",
    "notFound": "Hazvina kuwanikwa",
    "tryAgain": "Edzazve",
    "retry": "Edzazve",
    "undo": "Dzorerazve",
    "pullToRefresh": "Dhonzera kuti uvandudze",
    "justNow": "kungobva"
  },
  "auth": {
    "welcome": "Mauya kuFishMemory",
    "tagline": "Mubatsiri wako weWhatsApp wezvirangaridzo, zvino muruoko rwako.",
    "subtitle": "Mubatsiri wako weWhatsApp wezvirangaridzo, zvino muruoko rwako.",
    "phoneLabel": "Nhamba yako yeWhatsApp",
    "phoneHint": "Tichakutumira kodhi yekusimbisa kuburikidza neWhatsApp",
    "invalidPhone": "Ndapota nyora nhamba yefoni yakarurama",
    "continue": "Ramba",
    "enterPhone": "Nyora nhamba yako yeWhatsApp",
    "phonePlaceholder": "Nhamba yefoni",
    "sendCode": "Tumira Kodhi",
    "verifyTitle": "Simbisa nhamba yako",
    "otpSentTo": "Kodhi ine manhamba 6 yatumirwa ku{{phone}} kuburikidza neWhatsApp",
    "enterFullCode": "Ndapota nyora manhamba ese 6",
    "invalidOtp": "Kodhi isiriyo. Edzazve.",
    "otpFailed": "Kutumira kodhi kwakundikana. Edzazve.",
    "otpResent": "Kodhi yatumwazve",
    "resendIn": "Tumirazve mumasekondi {{seconds}}",
    "resendCode": "Tumirazve kodhi",
    "enterOtp": "Nyora kodhi yatakutumira kuWhatsApp yako",
    "verify": "Simbisa",
    "resend": "Tumirazve kodhi",
    "wrongNumber": "Nhamba isiriyo?",
    "backToPhone": "Dzoka kune nhamba",
    "editPhone": "Gadzirisa nhamba yefoni",
    "error": "Kukanganisa",
    "setupTitle": "Ngatigadzirisei zvinhu",
    "setupSubtitle": "Unogona kugara uchichinja izvi gare gare muZvirongwa",
    "namePlaceholder": "Zita rako",
    "letsGo": "Pedzisa gadziriro",
    "skipForNow": "Svetuka izvozvi"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Nyora meseji...",
    "inputPlaceholder": "Nyora meseji...",
    "typing": "FishMemory iri kunyora...",
    "online": "Pamhepo",
    "connecting": "Kubatanidza...",
    "reconnecting": "Kubatanidza zvakare...",
    "offline": "Hazvina pamhepo",
    "empty": "Tanga kutaura",
    "emptyHint": "Gadzira zvirangaridzo, tarisa karenda, kana bvunza rubatsiro.",
    "emptyAction": "Tumira chirangaridzo chemuenzaniso",
    "actions": "Zviito zvekutaura",
    "keep": "Chengeta mameseji",
    "clearTitle": "Bvisa kutaura",
    "clearConfirm": "Bvisa mameseji ese kubva mudivhisi rino? Hazvigoni kudzoserwa.",
    "clear": "Bvisa kutaura",
    "optionSelected": "Yakasarudzwa: {{label}}",
    "sendingSelection": "Kutumira...",
    "connectionLost": "Kubatanidza zvakare..."
  },
  "reminders": {
    "title": "Zvirangaridzo Zvangu",
    "active": "Zviri kushanda",
    "today": "Nhasi",
    "thisWeek": "Vhiki rino",
    "history": "Nhoroondo",
    "items": "zvinhu",
    "emptyTitle": "Hapana zvirangaridzo parizvino",
    "emptySubtitle": "Gadzira kubva mukutaura uye zvicharatidza pano.",
    "emptyAction": "Vhura kutaura",
    "filterActive": "Zviri kushanda",
    "filterToday": "Nhasi",
    "filterWeek": "Vhiki rino",
    "filterHistory": "Nhoroondo",
    "emptyState": "Hapana zvirangaridzo. Tanga kutaura!",
    "swipeDone": "Zvakaitwa",
    "swipeSnooze": "Snooze",
    "swipeDelete": "Bvisa",
    "search": "Tsvaga zvirangaridzo...",
    "upcoming": "Zviri kuuya",
    "completed": "Zvakapedzwa",
    "overdue": "Zvasara",
    "tomorrow": "Mangwana",
    "synced": "Zvakabatana {{value}}",
    "swipeHint": "Swipe chirangaridzo kuti uwane zvimwe zviito",
    "noResults": "Hapana zvirangaridzo zvinoenderana netsvaga yako",
    "noResultsHint": "Edza izwi rakasiyana kana bvisa kutsvaga",
    "deleteAllFailed": "Kutadza kubvisa zvirangaridzo zvese"
  },
  "calendar": {
    "title": "Karenda",
    "today": "Nhasi",
    "tomorrow": "Mangwana",
    "completed": "zvakaitwa",
    "noEvents": "Hapana zvakarongeka",
    "noEventsSubtitle": "Sarudza zuva kuti uone zvirangaridzo nezviitiko zvekarenda.",
    "googleEvent": "Google Calendar",
    "legendActive": "Zviri kushanda",
    "legendRecurring": "Zvinodzokororwa",
    "legendDone": "Zvakaitwa",
    "legendGoogle": "Google",
    "previousMonth": "Mwedzi wapfuura",
    "nextMonth": "Mwedzi unotevera",
    "previousYear": "Gore rapfuura",
    "nextYear": "Gore rinotevera",
    "goToToday": "Enda kuNhasi",
    "all": "Zvese",
    "active": "Zviri kushanda",
    "done": "Zvakaitwa",
    "paused": "Zvimire"
  },
  "settings": {
    "title": "Zvirongwa",
    "profile": "Mbiri",
    "name": "Zita Rinoratidzwa",
    "enterName": "Nyora zita rako",
    "language": "Mutauro",
    "uiLanguage": "Mutauro weApp",
    "uiLanguageHelp": "Inochinja UI yeapp, mazita ekarenda, uye nzira yekuona pane mudziyo uno chete.",
    "serverLanguage": "Mutauro wekutaura",
    "serverLanguageHelp": "Inochinja mutauro unoshandiswa nemhinduro dze server nemashoko ezvirangaridzo zveakaundi yako.",
    "timezone": "Nguva Yenzvimbo",
    "currentTimezone": "Nguva yenzvimbo yazvino",
    "timezoneHelp": "Nguva dzese dzezvirangaridzo dzino ratidzwa uchishandisa nguva yenzvimbo iyi.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Chengeta nguva yenzvimbo",
    "timezoneSaved": "Nguva yenzvimbo yagadziridzwa",
    "detect": "Ziva",
    "detectFailed": "Hatikwanise kuona nguva yenzvimbo",
    "autoDetect": "Ziva otomatiki kubva kuGPS",
    "notifications": "Zviziviso",
    "notificationsHelp": "Zvirangaridzo zvekutevera zvinodzora kuziviswa kunodzokororwa mushure mekunge chirangaridzo chasvika. Mvumo dzezviziviso padivhisi dzichiri kutarisirwa muzvirongwa zvemafoni ako.",
    "pushEnabled": "Zviziviso zvePush",
    "autoDoneOnFire": "Otomatiki nyora sechapedzwa kana zvaitika",
    "autoDoneOnFireDesc": "Kana zvisiri, zvirangaridzo zvinoramba zviri kushanda kusvikira wanyora sechapedzwa.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Yabatanidzwa",
    "googleDisconnected": "Haisati yabatanidzwa",
    "googleConnectedHelp": "Zvirangaridzo zvitsva zvinogona kuwiriraniswa nekarenda yako otomatiki.",
    "googleDisconnectedHelp": "Batanidza Google Calendar kuti zvirangaridzo nezviitiko zvifambirane.",
    "googleConnectFailed": "Kutadza kubatanidza Google Calendar",
    "connected": "Yabatanidzwa",
    "disconnected": "Haisati yabatanidzwa",
    "connect": "Batanidza",
    "disconnect": "Bvisa kubatana",
    "autoSync": "Otomatiki batanidza zvirangaridzo zvitsva",
    "autosync": "Otomatiki batanidza zvirangaridzo zvitsva",
    "subscription": "Kunyorera",
    "trialUsed": "Kuyedza: {{used}}/{{total}} yashandiswa",
    "trialStatus": "Kuyedza kuripo",
    "activeStatus": "Kunyorera kuri kushanda",
    "expiredStatus": "Kunyorera kwapera",
    "unsubscribedStatus": "Hakuna kunyorera",
    "about": "Nezve",
    "version": "Shanduro",
    "logout": "Buda",
    "logoutTitle": "Buda",
    "logoutConfirm": "Uri kuona chokwadi here kuti unoda kubuda?",
    "noName": "Hapana zita rakaiswa",
    "serverConnection": "Kubatanidza server",
    "serverUrl": "URL yeServer",
    "serverEdit": "Gadzirisa",
    "saveReconnect": "Chengeta uye batidza zvakare",
    "resetDefault": "Dzorerazve default",
    "invalidServerUrlTitle": "URL ye server isiriyo",
    "invalidServerUrlMessage": "Nyora URL ye server yakarurama http kana https, semuenzaniso https://example.com",
    "uiLanguageChangeFailed": "Kutadza kuchinja mutauro weapp. Edzazve.",
    "serverLanguageChangeFailed": "Kutadza kuchinja mutauro wekutaura. Edzazve.",
    "timezoneChangeFailed": "Kutadza kuchinja nguva yenzvimbo. Edzazve.",
    "autoSyncChangeFailed": "Kutadza kugadzirisa otomatiki batanidza. Edzazve.",
    "nameChangeFailed": "Kutadza kugadzirisa zita rinoratidzwa. Edzazve.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Zvimwe nezve chirangaridzo",
    "editTime": "Gadzirisa Nguva",
    "rename": "Chinja zita",
    "snooze": "Snooze",
    "snooze15": "Snooze maminitsi 15",
    "pause": "Mira",
    "pauseReminder": "Mira chirangaridzo",
    "resume": "Rambazve",
    "resumeReminder": "Rambazve chirangaridzo",
    "skip": "Svetuka Rinotevera",
    "skipOccurrence": "Svetuka chiitiko ichi",
    "syncGoogle": "Batanidza kuGoogle",
    "delete": "Bvisa",
    "deleteTitle": "Bvisa Chirangaridzo",
    "deleteConfirm": "Chirangaridzo ichi chichabviswa zvachose.",
    "deleteRecurringTitle": "Bvisa Chirangaridzo Chinodzokororwa",
    "deleteRecurringMessage": "Unoda kusvetuka chiitiko ichi here kana kubvisa zvese?",
    "deleteThisOccurrence": "Svetuka Chiitiko",
    "deleteEntireSeries": "Bvisa Zvese",
    "done": "Zvakaitwa",
    "markDone": "Nyora sechapedzwa",
    "undo": "Dzorerazve",
    "undoPrompt": "Unoda kuti chirambe chiri kushanda here? Dzorerazve izvozvi.",
    "recurring": "Chinodzokororwa",
    "nextRun": "Inotevera",
    "oneTime": "Kamwe chete",
    "pending": "Ichiri",
    "sent": "Yatumirwa",
    "paused": "Yamira",
    "active": "Iri kushanda",
    "snoozed": "Yasnooze",
    "localTime": "Inoratidzwa nenguva yako yenzvimbo",
    "recurrence": "Kudzokorora",
    "created": "Yakagadzirwa",
    "tags": "Matagi",
    "fireCount": "Nguva dzakaitika",
    "actions": "Zviito",
    "none": "Hapana",
    "snoozeFailed": "Kutadza kusnooze chirangaridzo",
    "pauseFailed": "Kutadza kumisa chirangaridzo",
    "resumeFailed": "Kutadza kurambazve chirangaridzo",
    "skipFailed": "Kutadza kusvetuka chirangaridzo",
    "doneFailed": "Kutadza kunyora chirangaridzo sechapedzwa",
    "undoFailed": "Kutadza kudzorerazve mamiriro echirangaridzo",
    "deleteFailed": "Kutadza kubvisa chirangaridzo",
    "rescheduleTitle": "Kudzokorora here?",
    "rescheduleMsg": "Chirangaridzo ichi chasara. Ungada kudzokorora here?",
    "reschedule15": "Mumaminitsi 15",
    "reschedule60": "Mumaawa 1",
    "keepOverdue": "Ramba sezvariri"
  },
  "onboarding": {
    "slide1Title": "Mauya kuFishMemory",
    "slide1Sub": "Mubatsiri wako wezvirangaridzo - uchishandisa WhatsApp uye wakagadzirirwa ruoko rwako.",
    "slide2Title": "Taura Zvakasununguka",
    "slide2Sub": "Nyora zvirangaridzo sezvaunofunga: \"Rangarira kundifonera amai mangwana na3pm\" — isu tichaita zvimwe.",
    "slide3Title": "Usapotsa Chinhu",
    "slide3Sub": "Gamuchira ziviso nenguva, ronga nematagi, uye gara pamusoro pezvinhu zvese zvinokosha.",
    "getStarted": "Tanga",
    "next": "Inotevera",
    "firstReminderTitle": "Gadzira chirangaridzo chako chekutanga!",
    "firstReminderHint": "Edza kunyora chimwe chinhu senge:",
    "firstReminderExample": "Rangarira kunwa mvura mangwana na9 AM",
    "gotIt": "Ndazvinzwisisa!",
    "notifRationaleTitle": "Ramba Panguva",
    "notifRationaleBody": "FishMemory inoda ziviso kuti ikurangaridze nenguva. Uchagamuchira ziviso chete yezvirangaridzo zvawagadzira.",
    "notifRationaleAllow": "Bvumira Zviziviso",
    "notifRationaleLater": "Pamwe Gare Gare",
    "swipeHint": "Swipe kurudyi kuti uwane zviito nekukurumidza →",
    "calendarDragHint": "Dhonzera kuti uwedzere ↕"
  }
}
